import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { updateSettings } from "../../../../redux/reducers/authSlice";
import Spinner from "../../../../components/Spinner";

export default function Account() {
  const dispatch = useDispatch();
  const { userDetail, loading } = useSelector((state) => state.auth);

  const validationSchema = Yup.object({
    firstName: Yup.string().required("First name is required"),
    lastName: Yup.string().required("Last name is required"),
    street: Yup.string().required("Street is required"),
    city: Yup.string().required("City is required"),
    country: Yup.string().required("Country is required"),
    state: Yup.string().required("State is required"),
    postalCode: Yup.string().required("Postal code is required"),
  });

  const formik = useFormik({
    initialValues: {
      firstName: userDetail?.firstName || "",
      lastName: userDetail?.lastName || "",
      email: userDetail?.email || "",
      street: userDetail?.street || "",
      city: userDetail?.city || "",
      country: userDetail?.country || "",
      state: userDetail?.state || "",
      postalCode: userDetail?.postalCode || "",
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      const { email, ...updateData } = values;
      dispatch(updateSettings(updateData));
    },
  });

  return (
    <Spinner active={loading}>
      <div className="display-card">
        <h3>Profile Information</h3>
        <p>Enter and Update your Profile Informations</p>
        <form onSubmit={formik.handleSubmit}>
          <div className="form-group row">
            <div className="col-xxl-6 col-lg-6 col-md-6 col-12 mb-3">
              <label>
                First Name <span className="required">*</span>
              </label>
              <input
                name="firstName"
                value={formik.values.firstName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={loading}
                className={`gbl-input ${formik.touched.firstName && formik.errors.firstName ? "is-invalid" : ""}`}
                placeholder="Enter First Name"
              />
              {formik.touched.firstName && formik.errors.firstName && (
                <div className="invalid-feedback">{formik.errors.firstName}</div>
              )}
            </div>
            <div className="col-xxl-6 col-lg-6 col-md-6 col-12 mb-3">
              <label>
                Last Name <span className="required">*</span>
              </label>
              <input
                name="lastName"
                value={formik.values.lastName}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={loading}
                className={`gbl-input ${formik.touched.lastName && formik.errors.lastName ? "is-invalid" : ""}`}
                placeholder="Enter Last Name"
              />
              {formik.touched.lastName && formik.errors.lastName && (
                <div className="invalid-feedback">{formik.errors.lastName}</div>
              )}
            </div>
            <div className="col-xxl-6 col-lg-6 col-md-6 col-12 mb-3">
              <label>
                Email <span className="required">*</span>
              </label>
              <input
                value={formik.values.email}
                className="gbl-input"
                placeholder="Email Address"
                disabled
              />
            </div>
            <div className="col-xxl-6 col-lg-6 col-md-6 col-12 mb-3">
              <label>
                Street <span className="required">*</span>
              </label>
              <input
                name="street"
                value={formik.values.street}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={loading}
                className={`gbl-input ${formik.touched.street && formik.errors.street ? "is-invalid" : ""}`}
                placeholder="Enter Street"
              />
              {formik.touched.street && formik.errors.street && (
                <div className="invalid-feedback">{formik.errors.street}</div>
              )}
            </div>
            <div className="col-xxl-6 col-lg-6 col-md-6 col-12 mb-3">
              <label>
                City <span className="required">*</span>
              </label>
              <input
                name="city"
                value={formik.values.city}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={loading}
                className={`gbl-input ${formik.touched.city && formik.errors.city ? "is-invalid" : ""}`}
                placeholder="Enter City"
              />
              {formik.touched.city && formik.errors.city && (
                <div className="invalid-feedback">{formik.errors.city}</div>
              )}
            </div>
            <div className="col-xxl-6 col-lg-6 col-md-6 col-12 mb-3">
              <label>
                Country <span className="required">*</span>
              </label>
              <input
                name="country"
                value={formik.values.country}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={loading}
                className={`gbl-input ${formik.touched.country && formik.errors.country ? "is-invalid" : ""}`}
                placeholder="Enter Country"
              />
              {formik.touched.country && formik.errors.country && (
                <div className="invalid-feedback">{formik.errors.country}</div>
              )}
            </div>
            <div className="col-xxl-6 col-lg-6 col-md-6 col-12 mb-3">
              <label>
                State <span className="required">*</span>
              </label>
              <input
                name="state"
                value={formik.values.state}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={loading}
                className={`gbl-input ${formik.touched.state && formik.errors.state ? "is-invalid" : ""}`}
                placeholder="Enter State"
              />
              {formik.touched.state && formik.errors.state && (
                <div className="invalid-feedback">{formik.errors.state}</div>
              )}
            </div>
            <div className="col-xxl-6 col-lg-6 col-md-6 col-12 mb-3">
              <label>
                Postal Code <span className="required">*</span>
              </label>
              <input
                name="postalCode"
                value={formik.values.postalCode}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                disabled={loading}
                className={`gbl-input ${formik.touched.postalCode && formik.errors.postalCode ? "is-invalid" : ""}`}
                placeholder="Enter Postal Code"
              />
              {formik.touched.postalCode && formik.errors.postalCode && (
                <div className="invalid-feedback">{formik.errors.postalCode}</div>
              )}
            </div>
          </div>
          <div className="mt-3 text-center">
            <button
              className="btn btn-primary"
              type="submit"
              style={{ width: '200px' }}
              disabled={loading || !formik.dirty}
            >
              {loading ? "Updating..." : "Update"}
            </button>
          </div>
        </form>
      </div>
    </Spinner>
  );
}
